import { render, staticRenderFns } from "./AnonReferAFriend.vue?vue&type=template&id=1d9f81a4&"
import script from "./AnonReferAFriend.vue?vue&type=script&lang=ts&"
export * from "./AnonReferAFriend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports